interface CmsManifest {
  version: string;
  assets: Array<any>;
}

export default async function readManifest(url: string): Promise<CmsManifest> {
  const response = await fetch(url);
  if (response.body) {
    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let result = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        // Do something with last chunk of data then exit reader
        return JSON.parse(result) as CmsManifest;
      }
      // Otherwise do something here to process current chunk
      result += decoder.decode(value);
    }
  } else {
    return { version: "error", assets: [] };
  }
}
